export default __webpack_public_path__ + "02d4eaaa392986fb619fea7f9de83390.png";